import { styled } from 'styled-components';

export const DashBoardContainer = styled.div`
    display: flex;

    justify-content: space-between;
    background: var(--base);
`;